const styles = theme => ({
  root: {
    [theme.breakpoints.up(960)]: {
      paddingTop: 0,
    },
  },

  container: {
    [theme.breakpoints.down(600)]: {
      paddingBottom: '140px',
    },
  },
});
export default styles;
